// extracted by mini-css-extract-plugin
export default {"plainForm":"PasswordReset_plainForm__mOVHi","cancel":"PasswordReset_cancel__ymr+y","plainInputs":"PasswordReset_plainInputs__dsadh"};